import { useEffect, useMemo, useState } from "react";
import Modal from "../../Modal";
import FormField from "../../FormField";
import { useDispatch, useSelector } from "react-redux";
import { setLoader } from "../../../features/LoaderSlice";
import { useIntl } from "react-intl";
import useCollect from "../../../hooks/useCollect";
import useTracker from "../../../hooks/useTracker";
import { useLocation } from "react-router-dom";
import UnsavedModal from "../../UnsavedModal";
import { isFieldRestricted } from "../../../features/configSlice";
import {
  FieldContactEmail,
  FieldFirstName,
  FieldLastName,
  FieldSalutation,
  FieldTitle,
} from "../../../utils/controls";
const CreateNewIdentity = ({
  isOpen,
  setIsOpen,
  isUnsavedOpen,
  setIsUnsavedOpen,
}) => {
  const intl = useIntl();
  const controller_code = useSelector((state) => state.controllers.controller);
  const customer_scope = useSelector((state) => state.controller.scope);
  const state = useSelector((state) => state.config);
  const { countryLanguages } = useSelector((state) => state.controller);
  const dispatch = useDispatch();
  const {
    identityCollect,
    handleCollectSuccessMessage,
    handleCollectErrorMessage,
  } = useCollect();
  const createIdentityDetails = useSelector((state) => state.TrackerReducer);
  const { types: idTypesOptions } = useSelector((state) => state.types);
  const { createIdentityTracker, removeCreateIdentityTracker, pageTracker } =
    useTracker();
  const trackerDetails = useSelector((state) => state?.TrackerReducer);
  const location = useLocation();
  const [customSelectTypeActive, setCustomSelectTypeActive] = useState(false);
  const [customSelectLanguageActive, setCustomSelectLanguageActive] =
    useState(false);

  const [formData, setFormData] = useState({
    salutation: "",
    title: "",
    first_name: "",
    last_name: "",
    type: "",
    value: "",
    language: "",
    contact_email: "",
    hasSubmited: false,
  });
  useEffect(() => {
    if (idTypesOptions?.length && !formData?.type)
      setFormData((prev) => ({ ...prev, type: idTypesOptions[0]?.value }));
  }, [idTypesOptions]);
  useEffect(() => {
    if (countryLanguages?.length && !formData?.language)
      setFormData((prev) => ({
        ...prev,
        language: countryLanguages[0]?.value,
      }));
  }, [countryLanguages]);

  useEffect(() => {
    if (
      trackerDetails &&
      trackerDetails?.form_type == "create" &&
      trackerDetails?.modal_type == "create"
    ) {
      setFormData({ ...trackerDetails?.form });
      setIsOpen(true);
      setIsUnsavedOpen(true);
    }
  }, []);
  const haveRequiredValues = useMemo(() => {
    if (
      formData?.first_name &&
      formData?.last_name &&
      formData?.type &&
      formData?.value &&
      formData?.language
    )
      return true;
  }, [formData]);

  const handleChange = async (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    createIdentityTracker({ ...formData, [e.target.name]: e.target.value });
    pageTracker(location.pathname);
  };

  const handleCreateIdentity = async () => {
    setFormData((prev) => ({ ...prev, hasSubmited: true }));
    if (haveRequiredValues) {
      dispatch(setLoader({ loading: true, label: "" }));
      identityCollect(
        {
          ...formData,
          controller_code,
          customer_scope,
          collection_channel: "Truman UI",
          last_update_channel: "Truman UI",
        },
        true
      )
        .then((res) => {
          handleCollectSuccessMessage(res);
          dispatch(setLoader({ loading: false, label: "" }));
          handleDiscardUnsaved(true);
          removeCreateIdentityTracker();
        })
        .catch((error) => {
          handleCollectErrorMessage(error);
          dispatch(setLoader({ loading: false, label: "" }));
          // handleClose();
        });
    }
  };
  const handleCloseAndCancel = async () => {
    if (createIdentityDetails?.form_type !== "create") {
      setIsUnsavedOpen(false);
      setIsOpen(false);
    } else setIsUnsavedOpen(true);
  };
  const handleCloseAndCancelUnsaved = async () => {
    setIsUnsavedOpen(false);
  };
  const handleClickOutside = async () => {
    if (createIdentityDetails?.form_type !== "create") {
      setIsUnsavedOpen(false);
    } else setIsUnsavedOpen(true);
  };
  const handleDiscardUnsaved = async (refresh = false) => {
    setIsUnsavedOpen(false);
    setFormData({
      salutation: "",
      title: "",
      first_name: "",
      last_name: "",
      type: "",
      value: "",
      language: "",
      contact_email: "",
      hasSubmited: false,
    });
    setTimeout(() => {
      setIsOpen(false, refresh);
    }, 300);
    removeCreateIdentityTracker();
  };
  const handleCustomClick = (fieldName) => {
    if (fieldName === "type")
      setCustomSelectTypeActive(!customSelectTypeActive);
    else if (fieldName === "language")
      setCustomSelectLanguageActive(!customSelectLanguageActive);
  };
  return (
    <>
      <Modal
        title={intl.formatMessage({
          id: "id.new.title",
          defaultMessage: "Create New Main Identity",
        })}
        description={intl.formatMessage({
          id: "id.new.description",
          defaultMessage:
            "Please note creation of a new main identity will automatically send a remote consent invitation. If you already have HCP consent, please use the bulk upload feature instead",
        })}
        open={isOpen}
        setOpen={setIsOpen}
        okText={intl.formatMessage({
          id: "label.create",
          defaultMessage: "Create",
        })}
        canelText={intl.formatMessage({
          id: "label.cancel",
          defaultMessage: "Cancel",
        })}
        type="form"
        onSubmit={handleCreateIdentity}
        handleClose={handleCloseAndCancel}
        onCancel={handleCloseAndCancel}
        handleClickOutside={handleClickOutside}
      >
        <div className="row" style={{ marginBottom: 10 }}>
          {!isFieldRestricted(state, FieldSalutation) && (
            <div className="col-md-2">
              <div className="form-group">
                <FormField
                  formType="create"
                  value={formData?.salutation}
                  name="salutation"
                  type="text"
                  id="salutation"
                  label={intl.formatMessage({
                    id: "label.salutation",
                    defaultMessage: "Salutation",
                  })}
                  placeHolder={intl.formatMessage({
                    id: "id.new-placeholder.salutation",
                    defaultMessage: "Salutation",
                  })}
                  handleChange={handleChange}
                />
              </div>
            </div>
          )}
          {!isFieldRestricted(state, FieldTitle) && (
            <div className="col-md-2">
              <div className="form-group">
                <FormField
                  formType="create"
                  value={formData?.title}
                  name="title"
                  type="text"
                  id="title"
                  label={intl.formatMessage({
                    id: "label.title",
                    defaultMessage: "Title",
                  })}
                  placeHolder={intl.formatMessage({
                    id: "id",
                    defaultMessage: "Title",
                  })}
                  handleChange={handleChange}
                />
              </div>
            </div>
          )}
          {!isFieldRestricted(state, FieldFirstName) && (
            <div className="col-md-4">
              <div className="form-group">
                <FormField
                  formType="create"
                  value={formData?.first_name}
                  name="first_name"
                  type="text"
                  id="first_name"
                  label={intl.formatMessage({
                    id: "label.first-name",
                    defaultMessage: "First Name",
                  })}
                  placeHolder={intl.formatMessage({
                    id: "id.new-placeholder.first-name",
                    defaultMessage: "Please Enter First Name",
                  })}
                  handleChange={handleChange}
                  rules={{
                    required: true,
                    hasSubmitted: formData?.hasSubmited,
                  }}
                />
              </div>
            </div>
          )}
          {!isFieldRestricted(state, FieldLastName) && (
            <div className="col-md-4">
              <div className="form-group">
                <FormField
                  formType="create"
                  value={formData?.last_name}
                  name="last_name"
                  type="text"
                  id="last_name"
                  label={intl.formatMessage({
                    id: "label.last-name",
                    defaultMessage: "Last Name",
                  })}
                  placeHolder={intl.formatMessage({
                    id: "id.new-placeholder.last-name",
                    defaultMessage: "Please Enter Last Name",
                  })}
                  handleChange={handleChange}
                  rules={{
                    required: true,
                    hasSubmitted: formData?.hasSubmited,
                  }}
                />
              </div>
            </div>
          )}
        </div>
        <div className="row" style={{ marginBottom: 10 }}>
          <div className="col-md-4">
            <div className="form-group">
              <FormField
                formType="create"
                value={formData?.type}
                name="type"
                type="select"
                id="type"
                label={intl.formatMessage({
                  id: "label.id-type",
                  defaultMessage: "ID Type",
                })}
                placeHolder={intl.formatMessage({
                  id: "id.new-placeholder.id-type",
                  defaultMessage: "Please Select ID Type",
                })}
                handleChange={handleChange}
                options={idTypesOptions}
                rules={{
                  required: true,
                  hasSubmitted: formData?.hasSubmited,
                }}
                handleCustomClick={(e) => handleCustomClick(e.target.name)}
                customSelectActive={customSelectTypeActive}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <FormField
                formType="create"
                value={formData?.value}
                name="value"
                type="text"
                id="value"
                label={intl.formatMessage({
                  id: "label.id-value",
                  defaultMessage: "ID Value",
                })}
                placeHolder={intl.formatMessage({
                  id: "id.support-placeholder.id-value",
                  defaultMessage: "Please Enter Here",
                })}
                handleChange={handleChange}
                rules={{
                  required: true,
                  hasSubmitted: formData?.hasSubmited,
                }}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <FormField
                formType="create"
                value={formData?.language}
                name="language"
                type="select"
                id="language"
                label={intl.formatMessage({
                  id: "label.language",
                  defaultMessage: "Language",
                })}
                placeHolder={intl.formatMessage({
                  id: "id.new-placeholder.language",
                  defaultMessage: "Please Select Language",
                })}
                handleChange={handleChange}
                options={countryLanguages}
                rules={{
                  required: true,
                  hasSubmitted: formData?.hasSubmited,
                }}
                handleCustomClick={(e) => handleCustomClick(e.target.name)}
                customSelectActive={customSelectLanguageActive}
              />
            </div>
          </div>
        </div>
        {!isFieldRestricted(state, FieldContactEmail) && (
          <div className="row" style={{ marginBottom: 10 }}>
            <div className="col-md-12">
              <div className="form-group">
                <FormField
                  formType="create"
                  value={formData?.contact_email}
                  name="contact_email"
                  type="email"
                  id="contact_email"
                  label={intl.formatMessage({
                    id: "label.contact-email",
                    defaultMessage: " Contact Email",
                  })}
                  placeHolder={intl.formatMessage({
                    id: "id.new-placeholder.contact-email",
                    defaultMessage: "Please Enter Contact Email",
                  })}
                  handleChange={handleChange}
                  rules={{
                    required: formData?.contact_email,
                    hasSubmitted: formData?.hasSubmited,
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </Modal>
      <UnsavedModal
        title={intl.formatMessage({
          id: "unsaved.title",
          defaultMessage: "Unsaved changes",
        })}
        subTitle={intl.formatMessage({
          id: "unsaved.subtitle",
          defaultMessage: "Are you sure you want to leave?",
        })}
        description={intl.formatMessage({
          id: "unsaved.description",
          defaultMessage:
            "You have unsaved changes. You can leave and discard the changes or cancel to continue editing.",
        })}
        open={isUnsavedOpen}
        setOpen={setIsUnsavedOpen}
        okText={intl.formatMessage({
          id: "unsaved.discardchanges",
          defaultMessage: "Discard changes",
        })}
        canelText={intl.formatMessage({
          id: "label.cancel",
          defaultMessage: "Cancel",
        })}
        handleClose={handleCloseAndCancelUnsaved}
        handleDiscard={handleDiscardUnsaved}
      />
    </>
  );
};

export default CreateNewIdentity;
